import React from "react";
import {
  Star,
  TrendingUp,
  CreditCard,
  Headset,
  Wallet,
  GraduationCap,
} from "lucide-react";

const clientFeaturesData = [
  {
    icon: Star,
    text: "Ultra-Fast Execution",
  },
  {
    icon: TrendingUp,
    text: "Tight, Transparent Pricing",
  },
  {
    icon: CreditCard,
    text: "A Platform Designed for Everyone",
  },
  {
    icon: Headset,
    text: "Real Human Support, 24/7",
  },
  {
    icon: Wallet,
    text: "Secure & Fully Protected",
  },
  {
    icon: GraduationCap,
    text: "Everything in One Place",
  },
];

const ClientLoveFeatures = () => {
  return (
    <div className="client-features-section">
      <div className="client-features-header">
        <h1 className="client-features-main-title">
          Why clients will love us...
        </h1>
      </div>

      <div className="client-features-list">
        {clientFeaturesData.map((feature, index) => (
          <div key={index} className="client-features-item">
            {/* The image uses outline-style icons. Lucide icons are generally stroke-based. */}
            <div className="client-features-icon-wrapper">
              <feature.icon size={24} className="client-features-icon" />
            </div>
            <p className="client-features-text">{feature.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientLoveFeatures;
